import template from './shell.html';
import controller from './shell.controller';
import './shell.scss';

let shellComponent = {
  bindings: {},
  template,
  controller
};

export default shellComponent;



// WEBPACK FOOTER //
// ./client/app/common/layout/shell/shell.component.js